module.exports = __webpack_public_path__ + "static/media/news-image-placeholder.4b4773c5.jpeg";